import { useCallback } from 'react'
import React from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IDefaultDatePicker } from 'components/uiKit/DatePicker'
import DatePicker from 'components/uiKit/DatePicker'

const FieldDatePicker = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IDefaultDatePicker, number | null>) => {
  const handleChange = useCallback(
    (value: number | null) => onChange({ name, value }),
    [name, onChange],
  )

  return <DatePicker {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldDatePicker) as typeof FieldDatePicker
